<template>
  <div class="excellent-marketing-store">
    <div class="page-header">
      <div class="header-content">
        <div class="stars-container">
          <v-icon class="star-icon" color="#FFD700">mdi-star</v-icon>
          <v-icon class="star-icon" color="#FFD700">mdi-star</v-icon>
          <v-icon class="star-icon star-icon--large" color="#FFD700">mdi-star</v-icon>
          <v-icon class="star-icon" color="#FFD700">mdi-star</v-icon>
          <v-icon class="star-icon" color="#FFD700">mdi-star</v-icon>
        </div>
        <h1>우수 마케팅 매장 인증</h1>
        <p class="subtitle">
          우수 마케팅 매장 인증 배지를 달고,<br />
          투자 모집에 대한 고민을 없애 보세요!
        </p>
      </div>
    </div>

    <div class="certification-info">
      <div class="certification-criteria">
        <h2>인증 대상</h2>
        <ul>
          <li>대상1. 네이버 방문자 리뷰+블로그 리뷰 합계가 3,000개 이상인 매장</li>
          <li>대상2. 배달의 민족+쿠팡이츠+요기요 리뷰 합계가 5,000개 이상인 매장</li>
          <!-- <li>대상2. 배달의 민족 리뷰가 2,000개 이상인 매장</li> -->
          <li>대상3. AI 장사비서 3개월 패키지 활용 매장</li>
        </ul>
        <p class="criteria-description">
          우수 마케팅 매장은 매출 신장 요소가 큰 매장으로 판단되어, 한도 확대와 투자유치에 도움이 될
          수 있습니다.
        </p>
      </div>

      <div class="certification-process">
        <h2>우수 마케팅 인증 뱃지 신청 방법</h2>
        <ol>
          <li>
            <h3>1. 본인 매장의 네이버 플레이스 혹은 배달의 민족 리뷰수가 적힌 페이지를 캡처하여</h3>
            <div class="review-images">
              <div class="review-image">
                <img
                  src="@/assets/images/marketing-store/naverplace.png"
                  alt="네이버 플레이스 리뷰 예시"
                />
                <p>네이버 플레이스 리뷰 예시</p>
              </div>
              <div class="review-image">
                <img src="@/assets/images/marketing-store/baemin.png" alt="배달의민족 리뷰 예시" />
                <p>배달의민족 리뷰 예시</p>
              </div>
            </div>
          </li>
          <li>
            <h3>
              2. 고객 페이지 우측 하단 채널톡에 매장명/연락처/이름과 함께 캡처한 이미지를 남깁니다.
            </h3>
            <div class="channeltalk-image">
              <img src="@/assets/images/marketing-store/channeltalk.png" alt="채널톡 문의 예시" />
              <p>채널톡 문의 예시</p>
            </div>
          </li>
          <li>
            <h3>
              3. 펀다에이아이 담당자가 개별 확인 후 우수 마케팅 매장으로 인증하면 공시 페이지에 우수 마케팅
              매장 뱃지가 보입니다.
            </h3>
            <!-- <div class="image-placeholder">뱃지 예시 이미지가 들어갈 자리입니다</div> -->
          </li>
        </ol>
      </div>

      <div class="certification-notes">
        <p>※ AI 장사비서 패키지 이용 매장은 자동으로 우수마케팅 매장 뱃지가 올라갑니다.</p>
        <p>
          ※ 우수 마케팅 매장 뱃지가 대출의 조건은 아니며, 한도 산출 등 대출 심사와는 무관합니다.
        </p>
        <p>
          ※ 본 인증은 투자 유치 가능성을 높일 수 있는 참고자료로 활용되며, 실제 대출 가능 여부 및
          조건은 개별 심사에 따라 달라질 수 있습니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExcellentMarketingStore',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.excellent-marketing-store {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;

  .page-header {
    text-align: center;
    margin-bottom: 3rem;
    background: linear-gradient(135deg, #4b79e4, #2b4ea2);
    padding: 3rem 2rem;
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(75, 121, 228, 0.3);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: shine 3s infinite;
    }

    .header-content {
      position: relative;
      z-index: 1;

      .stars-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 1.5rem;

        .star-icon {
          font-size: 2rem;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
          transform-origin: center;
          animation: starTwinkle 2s infinite;

          &--large {
            font-size: 3rem;
          }

          @for $i from 1 through 5 {
            &:nth-child(#{$i}) {
              animation-delay: #{$i * 0.2}s;
            }
          }
        }
      }
    }

    h1 {
      font-size: 2.5rem;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 1rem;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .subtitle {
      font-size: 1.2rem;
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: 0;
      line-height: 1.6;
    }
  }

  @keyframes shine {
    0% {
      left: -100%;
    }
    20% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }

  @keyframes starTwinkle {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(0.95);
    }
  }

  .certification-info {
    > p {
      text-align: center;
      font-size: 1.2rem;
      margin-bottom: 3rem;
    }
  }

  .certification-criteria {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 1rem;
    margin-bottom: 2rem;

    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
      color: #333;
    }

    ul {
      list-style: none;
      padding: 0;
      margin-bottom: 1.5rem;

      li {
        margin-bottom: 1rem;
        padding-left: 1.5rem;
        position: relative;

        &:before {
          content: '•';
          position: absolute;
          left: 0;
          color: #007bff;
        }
      }
    }

    .criteria-description {
      color: #4163d5;
      font-size: 1.1rem;
      font-weight: 500;
      padding: 1rem;
      background: rgba(65, 99, 213, 0.1);
      border-radius: 0.5rem;
      margin: 0;
    }
  }

  .certification-benefits {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 1rem;
    margin-bottom: 2rem;

    p {
      margin-bottom: 1rem;
      color: #333;
      font-size: 1rem;
    }
  }

  .certification-process {
    margin-top: 3rem;

    h2 {
      font-size: 1.5rem;
      margin-bottom: 2rem;
      color: #333;
    }

    ol {
      list-style: none;
      padding: 0;
      counter-reset: process-counter;

      li {
        margin-bottom: 2rem;
        padding: 2rem;
        background: #fff;
        border-radius: 1rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        counter-increment: process-counter;

        h3 {
          font-size: 1.2rem;
          margin-bottom: 1rem;
          padding-left: 2.5rem;
          position: relative;

          &:before {
            content: counter(process-counter);
            position: absolute;
            left: 0;
            width: 2rem;
            height: 2rem;
            background: #007bff;
            color: #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
          }
        }

        .review-images {
          display: flex;
          gap: 2rem;
          margin-top: 1rem;

          @media (max-width: 768px) {
            flex-direction: column;
            gap: 1.5rem;
          }

          .review-image {
            flex: 1;
            text-align: center;

            img {
              width: 100%;
              max-width: 400px;
              border-radius: 0.5rem;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }

            p {
              margin-top: 0.5rem;
              color: #666;
              font-size: 0.9rem;
            }
          }
        }

        .channeltalk-image {
          text-align: center;
          margin-top: 1rem;

          img {
            width: 100%;
            max-width: 300px;
            border-radius: 0.5rem;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          p {
            margin-top: 0.5rem;
            color: #666;
            font-size: 0.9rem;
          }
        }

        .image-placeholder {
          background: #f8f9fa;
          padding: 2rem;
          text-align: center;
          border-radius: 0.5rem;
          margin-top: 1rem;
          color: #666;
        }
      }
    }
  }

  .certification-notes {
    margin-top: 3rem;
    padding: 2rem;
    background: #f8f9fa;
    border-radius: 1rem;

    p {
      margin-bottom: 0.5rem;
      color: #666;
      font-size: 0.9rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;

    .page-header {
      padding: 2rem 1rem;
      margin-bottom: 2rem;

      h1 {
        font-size: 2rem;
      }

      .subtitle {
        font-size: 1.1rem;
      }

      .stars-container {
        .star-icon {
          font-size: 1.5rem;

          &--large {
            font-size: 2rem;
          }
        }
      }
    }

    .certification-info {
      > p {
        font-size: 1.1rem;
        margin-bottom: 2rem;
      }
    }

    .certification-criteria {
      padding: 1.5rem;
    }

    .certification-process {
      ol {
        li {
          padding: 1.5rem;
          margin-bottom: 1.5rem;
        }
      }
    }

    .certification-notes {
      padding: 1.5rem;
    }
  }
}
</style>
